<template>
  <div class="personal">
    <Nav @identity="identity" :rType="4" ref="nav"></Nav>
    <div style="height: 80px"></div>

    <div class="personal-bottom">
      <div class="personal-bottom-bottom">
        <div class="personal-bottom-bottom-left">
          <slide @change="changeSlide"></slide>
        </div>
        <div class="personal-bottom-bottom-right">
          <div class="personal-bottom-bottom-right-top">
            <div>我的位置：</div>
            <el-breadcrumb class="daohang" separator-class="el-icon-arrow-right">
              <el-breadcrumb-item class="xinxi" :to="{ path: '/shezhiguanliyuan' }"><span>主播管理</span>
              </el-breadcrumb-item>
              <el-breadcrumb-item class="xinxi" :to="{ path: '/tianjiazhiboyuan' }">
                <span>添加直播源</span>
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="personal-bottom-bottom-right-bottom">
            <div class="content_box">
              <div class="content_item">
                <div class="content_item_box">
                  <div class="p_name">标题</div>
                  <input v-if="zhiboyuandata.isLive == 0" v-model="biaoti" class="content_input" type="text"
                    placeholder="请输入直播标题" />
                  <div v-else style="display: flex">
                    <input v-model="ModifyBiaoti" class="content_input min_inputs" type="text"
                      placeholder="请输入要修改直播标题" />
                    <div @click="xiugaibiaoti" style="
                        cursor: pointer;
                        width: 80px;
                        height: 40px;
                        background: #721edc;
                        margin-top: 20px;
                        font-size:14px;
                        text-align: center;
                        line-height: 40px;
                        border-radius: 0 5px 5px 0;
                        color: #fff;

                      ">
                      修改标题
                    </div>
                  </div>
                </div>
                <div class="content_item_box">
                  <div class="p_name">路线选择</div>
                  <div class="my_redio">
                    <input type="radio" checked="true" /><span style="margin-left: 8px">线路1</span>
                  </div>
                </div>

                <div class="content_item_box" v-if="zhiboyuandata.pushStreamInfo">
                  <div class="p_name">推流服务器</div>
                  <input :value="zhiboyuandata.pushStreamInfo?zhiboyuandata.pushStreamInfo.path:''" readonly
                    class="content_input min_inputs" type="text" />
                  <div style="display: flex; margin-top: 20px">
                    <div v-if="Fuzhi1" class="tag-read1"
                      :data-clipboard-text="zhiboyuandata.pushStreamInfo?zhiboyuandata.pushStreamInfo.path:''"
                      @click="fuzhi1" style="
                        width: 84px;
                        height: 40px;
                        background: #721edc;
                        border-radius: 0px 6px 6px 0px;
                        text-align: center;
                        font-size:14px;

                        color: #fff;
                        line-height: 40px;
                        cursor: pointer;
                      ">
                      复制
                    </div>
                    <div v-else style="
                        width: 84px;
                        height: 40px;
                        background: #e8d6ff;
                        font-size:14px;

                        color: #fff;
                        border-radius: 0px 6px 6px 0px;
                        text-align: center;
                        line-height: 40px;
                        cursor: pointer;
                      ">
                      已复制
                    </div>
                  </div>
                </div>
                <span class="message_alert">请将此处地域名拷贝到OBS中，旧域名或将无法使用</span>
                <div class="content_item_box" v-if="zhiboyuandata.pushStreamInfo">
                  <div class="p_name">直播码</div>
                  <input :value="zhiboyuandata.pushStreamInfo.stream" readonly class="content_input min_inputs"
                    type="text" />
                  <div style="display: flex; margin-top: 20px">
                    <div v-if="Fuzhi2" class="tag-read2" :data-clipboard-text="zhiboyuandata.pushStreamInfo.stream"
                      @click="fuzhi2" style="
                        width: 84px;
                        height: 40px;
                        background: #721edc;
                        border-radius: 0px 6px 6px 0px;
                        text-align: center;
                        font-size:14px;

                        color: #fff;
                        line-height: 40px;
                        cursor: pointer;
                      ">
                      复制
                    </div>
                    <div v-else style="
                        width: 84px;
                        height: 40px;
                        background: #e8d6ff;
                        color: #fff;
                        font-size:14px;

                        border-radius: 0px 6px 6px 0px;
                        text-align: center;
                        line-height: 40px;
                        cursor: pointer;
                      ">
                      已复制
                    </div>
                  </div>
                </div>
                <span class="message_alert">请将此串码复制到OBS并尽快开始串流，直播码10分钟有效</span>
                <div class="content_item_box">
                  <div class="p_name">直播类型</div>
                  <div class="room_type" v-if="categorieList.length>0">
                    <el-select style="flex: 1;margin-right:12px;" @change="changeCategor" v-model="categorieValue"
                      placeholder="请选择">
                      <el-option v-for="(item,index) in categorieList" :key="index" :label="item.categoryName"
                        :value="item.categoryId">
                      </el-option>
                    </el-select>
                    <el-select style="flex: 1;" v-model="childCategorieValue" placeholder="请选择">
                      <el-option v-for="(item,index) in categorieListChild" :key="index" :label="item.categoryName"
                        :value="item.categoryId">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="content_item_box" v-if="categorieValue == 7 ">
                  <div class="p_name">关联比赛</div>
                  <div class="aboutScope" v-if="categorieList.length>0">
                    <div class="searchTop">
                      <el-autocomplete v-model="serchCropeValue" style="width:100%;"
                        :fetch-suggestions="querySearchAsync" placeholder="请输入联赛名称" @select="handleSelect">
                      </el-autocomplete>
                      <div class="btnserach">搜索</div>
                    </div>
                    <div class="scopeContent">
                      <div class="leftBox">
                        <el-radio @change="changeRadio" v-for="(item,index ) in scopeRecentList" :key="index"
                          class="radioSelect" v-model="selectTypeId" :label="item.leagueId">{{item.nameCnShort}}
                        </el-radio>
                      </div>
                      <div class="rightBox">
                        <el-radio v-for="(item,index) in scopeList" :key="index" class="radioSelect"
                          v-model="selectMatchId" :label="item.matchId">{{item.homeTeam.nameCn}} VS
                          {{item.awayTeam.nameCn}}</el-radio>

                      </div>
                    </div>
                    <div v-if="changeScopeStatus" @click="changeScope" class="btn_aboutRoom" style="margin:12px;">
                      <div class="btnScope">切换比赛</div>
                    </div>
                    <!-- <el-select @change="changeCategor" v-model="categorieValue"  placeholder="请选择">
                          <el-option
                            v-for="(item,index) in categorieList"
                            :key="index"
                            :label="item.categoryName"
                            :value="item.categoryId">
                          </el-option>
                        </el-select>
                        <div style="margin-left: 16px;" v-if="categorieListChild.length>0">
                          <el-select v-model="childCategorieValue"  placeholder="请选择">
                            <el-option
                              v-for="(item,index) in categorieListChild"
                              :key="index"
                              :label="item.categoryName"
                              :value="item.categoryId">
                            </el-option>
                          </el-select>
                        </div> -->
                  </div>

                </div>


 <div class="userInfoData">
                        准确的比赛数据，能够在你直播期间，为你带来更多观众。
                      </div>
              </div>
            </div>

            <div style="display: flex;justify-content: center;margin: 30px 0 20px; ">


              <div @click="Over" v-if="zhiboyuandata.isLive == 1" class="btn_liveroom">
                结束直播
              </div>
              <div @click="Begin" v-if="zhiboyuandata.isLive == 0" class="btn_liveroom">
                开始直播
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div v-show="fuzhiSucceed2" style="
        position: absolute;
        top: calc(50% - 142px / 2);
        left: calc(50% - 248px / 2);
        text-align: center;
        height: 142px;
        border-radius: 6px;
        background-color: rgba(255, 255, 255, 1);
        width: 248px;
      ">
      <img style="margin-top: 30px" src="https://oss.ansongqiubo.com/assets/cuowu2.png" alt="" />
      <div style="margin-top: 20px">复制失败</div>
    </div>
    <div v-show="fuzhiSucceed" style="
        position: absolute;
        top: calc(50% - 142px / 2);
        left: calc(50% - 248px / 2);
        text-align: center;
        height: 142px;
        border-radius: 6px;
        background-color: rgba(255, 255, 255, 1);
        width: 248px;
      ">
      <img style="margin-top: 30px" src="https://oss.ansongqiubo.com/assets/personimage/tijiao.png" alt="" />
      <div style="margin-top: 20px">复制成功</div>
    </div>
    <div v-show="tishi" style="
        position: absolute;
        top: calc(50% - 142px / 2);
        left: calc(50% - 248px / 2);
        text-align: center;
        height: 142px;
        border-radius: 6px;
        background-color: rgba(255, 255, 255, 1);
        width: 248px;
      ">
      <img style="margin-top: 30px" src="https://oss.ansongqiubo.com/assets/personimage/tijiao.png" alt="" />
      <div style="margin-top: 20px">直播成功</div>
    </div>
    <div v-show="tishi1" style="
        position: absolute;
        top: calc(50% - 142px / 2);
        left: calc(50% - 248px / 2);
        text-align: center;
        height: 142px;
        border-radius: 6px;
        background-color: rgba(255, 255, 255, 1);
        width: 248px;
      ">
      <img style="margin-top: 30px" src="https://oss.ansongqiubo.com/assets/cuowu2.png" alt="" />
      <div style="margin-top: 20px">你还不是主播,可以去龙珠App申请主播哦～</div>
    </div>
    <div v-show="tishi2" style="
        position: absolute;
        top: calc(50% - 142px / 2);
        left: calc(50% - 248px / 2);
        text-align: center;
        height: 142px;
        border-radius: 6px;
        background-color: rgba(255, 255, 255, 1);
        width: 248px;
      ">
      <img style="margin-top: 30px" src="https://oss.ansongqiubo.com/assets/cuowu2.png" alt="" />
      <div style="margin-top: 20px">{{ tishiyu }}</div>
    </div>
    <div v-show="tishi3" style="
        position: absolute;
        top: calc(50% - 142px / 2);
        left: calc(50% - 248px / 2);
        text-align: center;
        height: 142px;
        border-radius: 6px;
        background-color: rgba(255, 255, 255, 1);
        width: 248px;
      ">
      <img style="margin-top: 30px" src="https://oss.ansongqiubo.com/assets/personimage/tijiao.png" alt="" />
      <div style="margin-top: 20px">结束直播成功</div>
    </div>
  </div>
</template>

<script>
  import qs from "qs";
  import slide from './template_slide.vue'
  import Nav from "../component/Nav.vue";
  import {registerIM} from '@/api/wyapi.js'
  import Clipboard from "clipboard";
  import {
    categoriesList,
    categorieAllList,
    liveEnd
  } from '@/api/lz.js';
  import {
    recentList,
    matchrecentList,
    matchRelevance
  } from '@/api/scope.js';
  export default {
    name: "App",
    data() {
      return {
        changeScopeStatus:false,
        scopeList: [],
        scopeRecentList: [],
        serchCropeValue: '',
        selectTypeId: '',
        selectMatchId: '',
        categorieValue: 7,
        childCategorieValue: '',
        selectCategorieIndex: 4,
        categorieList: [],
        categorieListChild: [],
        radio: 0,
        radio2: 0,
        b: 1,
        tishi: false,
        tishi1: false,
        tishi2: false,
        tishi3: false,
        fuzhiSucceed: false,
        ModifyBiaoti: "",
        fuzhiSucceed2: false,
        shoujihao: "",
        cooke: "",
        yanzhengma: "",
        data: [],
        zhiboyuandata: [],
        identitys: null, //判断是不是主播信息
        biaoti: "", //标题
        fufenleiId: 0,
        fufenleiIndex: 0, //父分类index
        child: 9, //子分类选择
        tishiyu: "", //提示语
        activeName: 1,
        Fuzhi1: true,
        Fuzhi2: true,
        timeout:null
      };
    },
    created() {
      this.cooke = localStorage.getItem("token");
      console.log(this.cooke);
    },
    mounted() {
      this.initData()
      this.identity();
    },
    methods: {
      changeScope(){
          if(this.categorieValue == 7 ){
            if(!this.selectMatchId){
              return this.$message.error('请关联具体比赛！');
            }
          }
          // 关联比赛
          matchRelevance({
            leagueId:this.selectTypeId,
            matchId:this.selectMatchId,
            matchType:1,
          }).then(res=>{
            console.log('关联成功',res);
            if(res.data.code ==200){
              this.$message.success('关联比赛成功')
            }else{
              this.$message.error('关联比赛有误')
            }
          })
      },
      changeRadio(e) {
        console.log('选择', e);
        this.selectrecentList(e)
      },
      initData() {
        this.categorieList = []
        categorieAllList({}).then(res => {
          console.log('全部的1', res);
          this.categorieList = res.data.data;

          this.categorieList.splice(0,1)
          // 默认足球的

          let index =this.categorieList.findIndex(item =>item.categoryId == this.categorieValue);
          this.categorieListChild = this.categorieList[index].children;
          if (this.categorieListChild && this.categorieListChild.length > 0) {

            this.childCategorieValue = this.categorieListChild[0].categoryId;

          }
          this.pushinfo();
        })
        //
        recentList({
          matchType: 1
        }).then(res => {
          this.scopeRecentList = res.data.data;

          if(this.scopeRecentList.length > 0){
            this.scopeRecentList = this.scopeRecentList.map(item=>{
              item.value = item.nameCnShort
              return item
            })
            let id = this.scopeRecentList[0].leagueId
            this.selectTypeId  = id
            this.selectrecentList(id)
          }

        })
        // categoriesList({}).then(res=>{
        //   if(res.data.code == 200){
        //     // this.categorieList = res.data.data;
        //     console.log('全部的2',res);
        //   }
        // })
      },
      selectrecentList(id) {
        matchrecentList({
          matchType: 1,
          leagueId: id
        }).then(res => {
          console.log('指定比赛信息', res);
          this.scopeList = res.data.data;
          if(this.scopeList.length>0){
            this.selectMatchId = '';
          }
        })
      },
      handleSelect(e) {
        console.log(e);
        this.selectTypeId  = e.leagueId;
        this.selectrecentList(e.leagueId)
      },
      querySearchAsync(queryString, cb) {
        var restaurants = this.scopeRecentList;
        console.log(queryString,restaurants);
        var results = queryString ? restaurants.filter(item=>item.nameCnShort.indexOf(queryString) != -1) : restaurants;
        clearTimeout(this.timeout);
        this.timeout =  setTimeout(() => {
          cb(results);
        }, 1000);
      },
      createStateFilter(queryString) {
        return (state) => {
          return (state.value.indexOf(queryString) === 0);
        };
      },
      changeCategor(e,val) {
        if(e == 1){
          this.childCategorieValue = 1
          return
        }

        this.selectCategorieIndex =  this.categorieList.findIndex(item =>item.categoryId == e);
        console.log( 'id',this.selectCategorieIndex,e,this.categorieList);
        this.categorieListChild = this.categorieList[this.selectCategorieIndex].children;
        if (this.categorieListChild && this.categorieListChild.length > 0) {
          if(val){
            this.childCategorieValue = val;
            this.categorieValue = e
          }else{
            this.childCategorieValue = this.categorieListChild[0].categoryId
          }
        }

      },
      // 新的
      changeSlide(data) {
        this.$router.push(data);
      },
      // 修改标题
      async xiugaibiaoti() {
        console.log(this.ModifyBiaoti);

        // 敏感词过滤
        if(this.ModifyBiaoti && this.ModifyBiaoti.length >0){
          // 查重----过滤关键字
          let keyWord = await  this.$store.dispatch('fifWord',{key:"roomNmaelist",value:this.ModifyBiaoti})
          if(keyWord.state){
            this.ModifyBiaoti = keyWord.value;
          }else{
            return
          }
        }





        this.$axios({
          headers: {
            device: "web",
            packageId: "1",
            version: "1.0.0",
            channel: "web",
            "authToken": this.cooke,
          },
          url: this.api + "/v1/room/modifyTitle",
          method: "post",
          data: {
            title: this.ModifyBiaoti,
          },
        }).then((res) => {
          console.log(res);
          if (res.data.message == "success") {
            this.$message({
              message: '标题修改成功',
              type: 'success'
            })
          } else {
            this.$message({
              message: '标题修改失败',
              type: 'error'
            })
          }
        });
      },
      fuzhi1() {
        var clipboard1 = new Clipboard(".tag-read1");
        const _this = this;
        clipboard1.on("success", function(e) {
          _this.fuzhiSucceed = true;
          _this.Fuzhi1 = false;
          setTimeout(() => {
            _this.fuzhiSucceed = false;
          }, 2000);
          setTimeout(() => {
            _this.Fuzhi1 = true;
          }, 60000);
        });
        clipboard1.on("error", function(e) {
          _this.fuzhiSucceed2 = true;
          setTimeout(() => {
            _this.fuzhiSucceed2 = false;
          }, 2000);
        });
      },
      fuzhi2() {
        var clipboard2 = new Clipboard(".tag-read2");
        const _this = this;
        clipboard2.on("success", function(e) {
          _this.fuzhiSucceed = true;
          _this.Fuzhi2 = false;
          setTimeout(() => {
            _this.fuzhiSucceed = false;
          }, 2000);
          setTimeout(() => {
            _this.Fuzhi2 = true;
          }, 60000);
        });
        clipboard2.on("error", function(e) {
          _this.fuzhiSucceed2 = true;
          setTimeout(() => {
            _this.fuzhiSucceed2 = false;
          }, 2000);
        });
      },
      //   获取开播前基本信息
      pushinfo() {
        this.$axios
          .get(this.api + "/v1/live/pushinfo", {
            params: {},
            headers: {
              device: "web",
              packageId: "1",
              channel: "web",
              version: "1.0.0",
              "authToken": localStorage.getItem("token"),
            },
          })
          .then((res) => {
            console.log(res);
            if (res.data.message == "success") {
              this.biaoti = res.data.data.room.title;
              this.ModifyBiaoti = res.data.data.room.title;
              this.zhiboyuandata = res.data.data;
              let arr = []
              this.zhiboyuandata.categories.forEach(item => {
                if (item.categoryId == 5 || item.categoryId == 7) {
                  arr.unshift(item)
                } else {
                  arr.push(item)
                }
              })
              this.zhiboyuandata.categories = arr;

               registerIM();

              let categorieValue = res.data.data.lastLiveParentCategoryId >0 ? Number( res.data.data.lastLiveParentCategoryId) : '';
              let childCategorieValue = res.data.data.lastLiveCategoryId > 0?Number(res.data.data.lastLiveCategoryId)  : '';

              this.changeCategor(categorieValue,childCategorieValue);
              
              setTimeout(()=>{
                if(this.zhiboyuandata.isLive == 1){
                  if(this.categorieValue == 7){
                    this.changeScopeStatus = true;
                  }else{
                    this.changeScopeStatus = false;
                  }

                }
              },0)


              console.log('当前直播的父分类id', this.categorieValue , this.childCategorieValue );




              let list = this.zhiboyuandata.categories
              list.forEach((item, i) => {
                if (item.categoryId == this.fufenleiId) {
                  this.fufenleiIndex = i
                  item.children.forEach((itm, v) => {
                    if (itm.categoryId == this.child) {
                      this.radio = v

                    }
                  })
                }
              })
            } else {
              alert(res.data.message);
            }
          });
      },
      //   选择子分类
      fenlei(e) {
        console.log(e);
        this.child = e;
      },
      //   直播选择分类父分类
      dianjifenlei(e, val) {
        if (e == 0) {
          this.child = 9;
        } else if (e == 1) {
          this.child = 12;
        } else if (e == 2) {
          this.child = 28;
        } else if (e == 3) {
          this.child = 39;
        } else if (e == 4) {
          this.child = 50;
        } else if (e == 5) {
          this.child = 63;
        }

        // if(this.zhiboyuandata.categories[e] && this.zhiboyuandata.categories[e].children[0])
        console.log(e, '数据', this.zhiboyuandata.categories[e].children[0].categoryId);
        this.child = this.zhiboyuandata.categories[e].children[0].categoryId;
        this.radio = 0
        //   console.log(this.child);
        this.fufenleiIndex = e;
        this.fufenleiId = val;
      },
      identity(e) {
        this.identitys = e;
      },
      Mingcheng(e, i) {
        console.log(e, i);
        if (e == 0 && i == 0) {
          this.$router.push("/personalc");
        }
        if (e == 0 && i == 1) {
          this.$router.push("/wodeguanzhu");
        }
        if (e == 0 && i == 2) {
          this.$router.push("/wodefensi");
        }
        if (e == 0 && i == 3) {
          this.$router.push("/lishiguankan");
        }
        if (e == 0 && i == 4) {
          this.$router.push("/wodezichan");
        }
        if (e == 0 && i == 5) {
          this.$router.push("/wodexinxi");
        }
        if (e == 1 && i == 0) {
          this.$router.push("/shezhiguanliyuan");
        }
        if (e == 1 && i == 1) {
          this.$router.push("/guanlijinyan");
        }
        // if (e==1&&i==2) {
        //     this.$router.push('/tianjiazhiboyuan')
        // }
        if (e == 2 && i == 0) {
          this.$router.push("/wodeshouyi");
        }
        if (e == 2 && i == 1) {
          this.$router.push("/yonghupaihangbang");
        }
        // if (e == 3&&i == 0) {
        //     this.$router.push('/shipinfabu')
        // }
        // if (e == 3&&i == 1) {
        //     this.$router.push('/ziyuanguanli')
        // }
        if (e == 3 && i == 0) {
          this.$router.push("/zhiboshuju");
        }
        // if (e==4&&i==1) {
        //     this.$router.push('/shipinshuju')
        // }
      },
      dianji(e) {
        this.b = e;
      },
      // 开始直播
      Begin() {
        // window._czc.push(['B0101', contentUrl, refererUrl])
        if (this.identitys == 2) {

          if(this.categorieValue == 7 ){
            if(!this.selectMatchId){
              return this.$message.error('请关联具体比赛！');
            }
          }

          console.log(this.biaoti);
          this.$axios({
            headers: {
              device: "web",
              packageId: "1",
              version: "1.0.0",
              channel: "web",
              "authToken": this.cooke,
              "Content-Type": "application/x-www-form-urlencoded",
            },
            transformRequest: [
              function(data) {
                //在请求之前对data传参进行格式转换
                data = qs.stringify(data);
                console.log(data);
                return data;
              },
            ],
            url: this.api + "/v1/live/start",
            method: "post",
            data: {
              cover: "",
              title: this.biaoti,
              categoryId: this.childCategorieValue,
           },
          }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
              this.$refs.nav.zhibotishi = true;
              this.tishi = true;
              setTimeout(() => {
                this.pushinfo();
                this.tishi = false;
              }, 2000);

              this.ModifyBiaoti = this.biaoti;
              if(this.categorieValue == 7 ){
                // 关联比赛
                matchRelevance({
                  leagueId:this.selectTypeId,
                  matchId:this.selectMatchId,
                  matchType:1,
                }).then(res=>{
                  console.log('关联成功',res);
                })
              }

            } else {
              this.tishiyu = res.data.message;
              console.log(this.tishiyu);
              this.tishi2 = true;
              setTimeout(() => {
                this.tishi2 = false;
              }, 2000);
            }
          });
        } else {
          this.tishi1 = true;
          setTimeout(() => {
            this.tishi1 = false;
          }, 2000);
        }
      },
      // 结束直播
      Over() {
        liveEnd({

        }).then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            this.$refs.nav.zhibotishi = false;
            this.tishi3 = true;

            this.changeScopeStatus = false;
                this.initData();
            setTimeout(() => {

              this.tishi3 = false;
            }, 2000);

          } else {
            this.tishi2 = true;
            setTimeout(() => {
              this.tishi2 = false;
            }, 2000);
          }
        });
      },
    },
    components: {
      Nav,
      slide
    },
  };
</script>

<style scoped lang='scss'>
  .btn_aboutRoom{
    display: flex;
    justify-content: center;
    .btnScope{
      width: 64px;
      cursor: pointer;
      height: 20px;
      border-radius: 2px;
      border: 1px solid #721EDC;
      text-align: center;
      line-height: 20px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #721EDC;
    }
  }
  ::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 3px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 8px;
  }

  ::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    //background-color: #8c8c8c;
    background-color: rgba(0, 0, 0, 0.25);
  }

  ::-webkit-scrollbar-track {
    background-color: #f6f6f6;
  }

  ::-webkit-scrollbar-thumb,
  ::-webkit-scrollbar-track {
    border: 0;
  }

  .myselectbox {
    border-radius: 8px !important;
    background: #e6e0e0 !important;
    color: #fff !important;
  }

  .personal {
    width: 100vw;
    background: #f7f8fa;

    .xzcxzcxz {
      color: rgba(114, 30, 220, 1) !important;
    }

    .personal-bottom {
      background-color: #f7f8fa;
    }

    .personal-bottom-top {
      width: 100%;
      height: 60px;
      min-width: 1240px;
      background-color: #fff;
    }

    .personal-bottom-top-div {
      width: 1240px;
      height: 60px;
      margin: 0 auto;
      color: #333;
      font-size: 23px;
      line-height: 60px;
      display: flex;
      align-items: center;
    }

    .personal-bottom-top-div-div {
      width: 6px;
      height: 50px;
      background-color: #721edc;
      border-radius: 6px;
    }
  }

  .personal-bottom-bottom {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    background-color: #f7f8fa;
    min-width: 1200px;

    .personal-bottom-bottom-left {
      width: 190px;
      height: 100%;
      background-color: #fff;
      margin-top: 16px;
      color: #333;

      .myel-collapse-item {
        width: 190px;
      }

      .prent_item {
        text-align: center;
        width: 100%;
        height: 100%;
        display: flex;

        .parent_icon {
          display: flex;
          align-items: center;
        }

        .parent_name {
          display: flex;
          align-items: center;
          font-size: 14px;
        }
      }

      .child_item {
        color: #a6a6a6;
        width: 100%;
        height: 52px;
        line-height: 52px;
        background-color: #f2f2f2;

        .child_img {
          display: flex;
          align-items: center;
        }

        .child_name {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          text-align: center;
          cursor: pointer;
        }
      }
    }
  }

  .personal-bottom-bottom-right {
    margin-left: 12px;
    height: 100%;
    max-width: 998px;
    background-color: #fff;
    flex: 2;
    height: calc(100vh - 80px);
    overflow-y: scroll;
    padding: 30px 20px;
    box-sizing: border-box;
    margin-top: 16px;
  }

  .personal-bottom-bottom-right-top {
    background-color: #fff;
    display: flex;
    align-items: center;
  }

  .personal-bottom-bottom-right-top-left {
    width: 8px;
    height: 100%;
    background-color: #721edc;
  }

  .personal-bottom-bottom-right-top>span {
    /* width: 8px;
    height: 53px; */
    color: white;
    margin-left: 20px;
    font-size: 24px;
  }

  .personal-bottom-bottom-right-bottom {
    min-height: calc(94% - 15px);
    box-sizing: border-box;
    margin-top: 25px;
    padding-top: 15px;
    border-top: 1px solid rgba(0, 0, 0, 0.2);
    position: relative;
    display: flex;
    flex-direction: column;

    .btn_liveroom {
      user-select: none;
      cursor: pointer;
      margin-top: 20px;
      align-self: center;
      width: 130px;
      height: 36px;
      background: #721edc;
      border-radius: 4px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      text-align: center;
      line-height: 36px;
    }
    .userInfoData:before{
      content: '*';
      margin-right: 4px;
      font-size: 12px;
    }
    .userInfoData{
      margin: 14px 0;
      font-size: 12px;
      color: #ff0000;
      margin-left: 100px                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          ;
    }
    /* box-sizing: border-box; */
    .content_box {
      display: flex;

      .content_item {
        .content_item_box {
          display: flex;
          align-items: flex-start;

          .aboutScope {
            margin-top: 20px;
            width: calc(380px + 84px);
            background: #F7F8FA;
            border-radius: 4px;
            padding: 10px 12px 0;
            display: flex;
            flex-direction: column;

            .searchTop {
              display: flex;
              margin-bottom: 8px;
              align-items: center;
              position: relative;

              /deep/ input {
                padding-right: 60px;
              }
            }

            .scopeContent {
              display: flex;
              justify-content: space-between;

              .radioSelect {
                margin-top: 20px;
              }

              /deep/ .el-radio__label {
                margin-left: 8px;
              }

              /deep/ .el-radio {
                margin-right: 0 !important;
              }
            }

            .btnserach {
              right: 20px;
              top: 50%;
              transform: translateY(-50%);
              position: absolute;
              width: 48px;
              height: 20px;
              background: #721EDC;
              border-radius: 4px;
              text-align: center;
              line-height: 20px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #FFFFFF;
            }

            .leftBox {
              padding: 16px 10px;
              width: 140px;
              display: flex;
              flex-direction: column;
              height: 194px;
              background: #FFFFFF;
              border-radius: 4px;
              margin-right: 12px;
              overflow-y: scroll;
            }

            .rightBox {
              display: flex;
              flex-direction: column;
              padding: 16px 10px;
              flex: 2;
              height: 194px;
              background: #FFFFFF;
              border-radius: 4px;
              overflow-y: scroll;
            }
          }
        }

        .message_alert {
          margin-left: 100px;
          color: red;
          font-size: 12px;
        }

        .right_iut {
          box-sizing: border-box;
          color: #333;
          padding: 0 15px;
          width: 402px;
          height: 40px;
          line-height: 40px;
          border-radius: 4px 0px 0px 4px;
          white-space: nowrap;
          overflow: hidden;
        }

        .p_name {
          width: 100px;
          height: 40px;
          line-height: 40px;
          margin-top: 20px;
        }

        .my_redio {
          line-height: 40px;
          color: #333;
          margin-top: 20px;
          width: 486px;
          height: 40px;
          font-size: 14px;
        }

        .content_input {
          box-sizing: border-box;
          padding: 0 15px;
          margin-top: 20px;
          width: 486px;
          height: 40px;
          border-radius: 4px;
          color: #666;
        }

        div {
          user-select: none;
        }

        .room_type {
          overflow: hidden;
          padding: 0 4px;
          box-sizing: border-box;
          display: flex;
          width: 488px;
          justify-content: space-between;
          margin-top: 20px;
          border-radius: 4px 6px 6px 4px;
        }

        .left_type {
          display: flex;
        }

        .room_type_item {
          cursor: pointer;
          text-align: center;
          background: #f7f8fa;
          width: 87px;
          padding: 8px 0;
          margin-bottom: 10px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
        }

        .room_type_item:hover {
          border-radius: 8px;

          background: #e6e0e0;
          color: #fff;
        }

        .room_type_item:last-child {
          margin-bottom: none;
        }

        .btn_liveroom {
          cursor: pointer;
          margin: 0 auto;
          margin-top: 100px;
          font-weight: 400;
          color: #ffffff;
          line-height: 40px;
          text-align: center;
          width: 176px;
          height: 40px;
          background: #721edc;
          border-radius: 4px;
        }

        input {
          outline-style: none;
          border: none;
          background: #f7f8fa;
          color: #666;
        }

        .min_inputs {
          border-radius: 4px 0 0 4px !important;
          width: 400px;
        }
      }
    }
  }

  .daohang {
    display: flex;
    color: white;
    width: 500px;
  }

  .xinxi {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
  }

  .xinxi:hover {
    color: #721edc;
  }

  .biao {
    width: 16px;
    height: 16px;
    background-image: url(https://oss.ansongqiubo.com/assets/personimage/jiantou.png);
  }

  .colorBiao {
    background-image: url(https://oss.ansongqiubo.com/assets/personimage/jiantou1.png) !important;
  }

  .a {
    background-color: #721edc;
  }

  .xzcxzcxz {
    color: white;
  }
</style>
<style>
  .el-radio__label {
    padding-left: 1px;
  }
</style>



// WEBPACK FOOTER //
// src/component/Tianjiazhiboyuan.vue